import {AppConfig, MapConfig} from "../models/config.model";

export function defaultAppConfig(): AppConfig {
  return {
    appName: 'PUMRS',
    envName: 'DEV',
    production: false,
    test: false,
    i18nPrefix: '',
    apiNucleoUrl: '',
    apiSeguroUrl: '',
    apiAuditoriaUrl: '',
    apiWebServiceUrl: '',
    socketUrl: '',
    sueloMetaUrl: '',
    reuneBaseUrl: '',
    useMockServer: false,
    logging: {
      serverLoggingUrl: null,
      level: 1/*NgxLoggerLevel.DEBUG*/,
      serverLogLevel: 1/*NgxLoggerLevel.OFF*/,
      disableConsoleLogging: false
    },
    oauth_idp: {
      url: '',
      client_id: '',
      redirect_uri: ''
    },
    // Elementos de prueba para el desarrollo
    oauth_user_free: {
      access_token: '',
      refresh_token: '',
      expires_in: 0
    },
    urlLayers: {
      alevacionTerreno: 'http://dgrn.mgap.gub.uy/arcgis/rest/services/GEOCOM/ModeloDigitalTerreno_color/ImageServer',
      CONEAT: 'http://dgrn.mgap.gub.uy/arcgis/rest/services/BASE_GCOM/CONEAT/MapServer',
      suelos: 'http://dgrn.mgap.gub.uy/arcgis/rest/services/BASE_GCOM/Suelos/MapServer',
      administrativas: 'http://dgrn.mgap.gub.uy/arcgis/rest/services/BASE_GCOM/Administrativo/MapServer',
      padrones: 'http://dgrn.mgap.gub.uy/arcgis/rest/services/BASE_GCOM/Administrativo/MapServer/0',
    },
    workConfig: {
      enable: false,
    },
    systemId: '',
    profileUrl: '',
    linksAdmin: [],
    arcgisServiceServer: '',
    tokenSistema: '',
  };
}

export function defaultMapConfig(): MapConfig {
  return {
    point: null,
    polygon: null,
    jobs: [],
    layers: [],
  };
}
